import React from 'react';
import { connect } from 'react-redux';

import store from '../store';

import {
    feedsRemoveFieldMap,
    feedsAddFieldMap,
    feedsSetFieldMap,
} from '../modules/Feeds/actions';

import FormFieldList from './FormFieldList';
import SobjectFieldList from './SobjectFieldList';

const $ = jQuery;
const { dispatch } = store;

class FieldMap extends React.Component {
    renderRemoveButton(sobjectName, idx) {
        if (idx <= 0) {
            return null;
        } else {
            return (
                <a className="remove-item" onClick={e => {
                    dispatch(feedsRemoveFieldMap({ sobjectName, idx, }));
                }}><span>-</span></a>
            );
        }
    }

    renderButtons() {
        const { sobjectName, feeds, idx, status } = this.props;

        if (status === 0) {
            return null;
        } else {
            return (
                <td>
                    <div className="repeater-buttons">
                        <a className="add-item" onClick={e => {
                            dispatch(feedsAddFieldMap(sobjectName));
                        }}><span>+</span></a>
                        {this.renderRemoveButton(sobjectName, idx)}
                    </div>
                </td>
            );
        }
    }

    render() {
        const { sobjectName, feeds, idx, status } = this.props;

        if (sobjectName == '') {
            return null;
        }

        return (
            <tr key={`fm_${idx}`}>
                <th>
                    <SobjectFieldList idx={idx} selected={feeds[sobjectName].field_map[idx].sf} onChange={e => {
                        dispatch(feedsSetFieldMap({ sf: e.target.value, sobjectName, idx, }));
                    }} />
                </th>
                <td>
                    <FormFieldList idx={idx} selected={feeds[sobjectName].field_map[idx].gf} />
                </td>
                {this.renderButtons()}
            </tr>
        )
    }
}

const mapStateToProps = function (store) {
    return {
        sobjectName: store.metaState.get('sobject').get('name'),
        feeds: store.feedsState.get('feeds').toJS(),
        status: store.metaState.get('status'),
    }
};

export default connect(mapStateToProps)(FieldMap);
